import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { Translations, I18nHelper } from "../../Lib/Helper/I18nHelper";
import { ProgressBar, ProgressBarMode } from "../Global/Progressbar";
import { AxDropdown } from "@axess/limestone";
import { BodyUtility } from "../../Components/AxUtility/BodyUtility";


@ModuleName("ServiceVoucherPersonalization")

export class ServiceVoucherPersonalization implements AxInit {
    private _i18nHelper = new I18nHelper();
    public ItemDropdown: AxDropdown = new AxDropdown();

    constructor(
        protected _Progressbar = new ProgressBar(),
        private _BodyUtility = new BodyUtility()
    ) { }

    AxInit() {

        this._Progressbar.Init({
            Mode: ProgressBarMode.Default,
            Progress: 0
        });

        this.ItemDropdown.init('.prod_selection__prod-selection .ax-dropdown');

        $('.prod_selection__prod-selection').on('click', (x => {
            $('.prod_selection__prod-wrapper').addClass('active');
            this._BodyUtility.DisableScroll();
        }));

        $('.prod_selection__prod-wrapper .prod_selection__prod-close').on('click', (x => {
            $('.prod_selection__prod-wrapper').removeClass('active');
            this._BodyUtility.EnableScroll();
        }));

        $('.tv4_quantity__info_expand').on('click', (x => {
            $('.tv4_quantity__info').toggleClass('active');
        }));

        $('#ServiceVoucher__addToCart').on('click', (x => {
            this.AddToCart();
        }));

        $('[data-service-voucher-preview]').on('click', (x => {
            this.getPreviewDocument();
        }));

        $('#service_voucher_preview_image [data-close-preview-modal]').on('click', (x => {
            $('#service_voucher_preview_image').removeClass('is-open');
            $('[data-body-preview-modal]').empty();
        }));
    }

    getPreviewDocument()
    {
        const ServiceVoucherForm = this.getServiceVoucherForm();

        AxessViewer.loadPartialView('/ServiceVoucher/GetPreviewDocument/', ServiceVoucherForm, (result) => {
            if (result.success) {
                $('#service_voucher_preview_image').addClass('is-open');
                var img = jQuery('<img class="dynamic" style="width:100%;">');
                img.attr('src', `data:image/png;base64,${result.imagePath}`);
                $('[data-body-preview-modal]').append(img)
            } else {
                Swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: result.errorMessage,
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                });
            }
        });
    }

    AddToCart() {

        $('#ServiceVoucher__addToCart').addClass('loading');
        $('#ServiceVoucher__addToCart').addClass('disabled');
        const ServiceVoucherForm = this.getServiceVoucherForm();


        AxessViewer.loadPartialView('/ServiceVoucher/AddToCart/', ServiceVoucherForm, (result) => {
            if (result.success) {
                AxLoad.LoadModule('AxFireShoppingCartModal', {
                    result: result,
                    continueShoppingPath: 'ServiceVoucher',
                    btn: '.ServiceVoucher__addToCart',
                    ResetQuantity: null
                });
            } else {
                Swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: result.errorMessage,
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                });
            }
        }, {
            silent: true,
        });
    }

    getServiceVoucherForm(): ServiceVoucherForm {
        return {
            VoucherId: Number($("#ServiceVoucher__Id").val()),
            VoucherFrom: $("#ServiceVoucher__From").val().toString(),
            VoucherTo: $("#ServiceVoucher__To").val().toString(),
            VoucherEmail: $("#ServiceVoucher__Email").val().toString(),
            VoucherMessage: $("#ServiceVoucher__Message").val().toString().replace(/[\r\n]+/g, " "),
        }
    }

}

interface ServiceVoucherForm {
    VoucherId: number,
    VoucherFrom: string,
    VoucherTo: string,
    VoucherEmail: string,
    VoucherMessage: string,

}